"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _theme = require("../../../../../theme");
var _Option = require("./Option");
var _Menu = require("./Menu");
var _ValueContainer = require("./ValueContainer");
var _MenuList = require("./MenuList");
var _Placeholder = require("./Placeholder");
var _DropdownIndicator = require("./DropdownIndicator");
var _Control = require("./Control");
var _SingleValue = require("./SingleValue");
var _SearchInput = require("./SearchInput");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var SelectInput = (0, _styledComponents.default)(function (props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.default, _extends({
    theme: _theme.theme,
    hideSelectedOptions: props.options.length >= 2 && !props.isMulti
  }, props, {
    isSearchable: props.isSearchable ? props.options.length > 5 : false,
    value: props.isMulti ? props.options.filter(function (o) {
      var _props$value;
      return (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.includes(o.value);
    }) : props.options.find(function (el) {
      return el.value === props.value;
    }),
    defaultValue: props.isMulti ? props.options.filter(function (o) {
      var _props$defaultValue;
      return (_props$defaultValue = props.defaultValue) === null || _props$defaultValue === void 0 ? void 0 : _props$defaultValue.includes(o.value);
    }) : props.options.find(function (el) {
      return el.value === props.defaultValue;
    }),
    onChange: function onChange(selected) {
      var _props$onChange, _props$onChange2;
      if (props.isMulti) return (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, selected.map(function (s) {
        return s.value;
      }));
      (_props$onChange2 = props.onChange) === null || _props$onChange2 === void 0 ? void 0 : _props$onChange2.call(props, selected.value);
    },
    components: _objectSpread({
      DropdownIndicator: _DropdownIndicator.DropdownIndicator,
      IndicatorSeparator: null,
      Option: _Option.Option,
      Input: props.isSearchable ? _SearchInput.SearchInput : null,
      ValueContainer: _ValueContainer.ValueContainer,
      Menu: _Menu.Menu,
      MenuList: _MenuList.MenuList,
      Placeholder: _Placeholder.Placeholder,
      Control: _Control.Control,
      SingleValue: _SingleValue.SingleValue
    }, props.components)
  }));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &:hover {\n    ", " path {\n      fill: ", ";\n    }\n  }\n"])), _DropdownIndicator.DropdownIndicator, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondaryShade2;
});
exports.SelectInput = SelectInput;